import { intlLocale, statusLabel, weekdayOptions } from '@/utils/i18nHelpers'

export default {
  computed: {
    intlLocale() {
      return intlLocale(this.$store.getters['app/locale'])
    },
  },
  methods: {
    statusLabel(status) {
      return statusLabel(this, status)
    },
    weekdayOptions() {
      return weekdayOptions(this)
    },
  },
}
